import React from "react";
import "./PreFooterCards.css";
import wp_logo from "../Assets/Images/whatsapp-logo.png";
import doc_logo from "../Assets/Images/document-logo.png";
import sec_logo from "../Assets/Images/secured-logo.png";

const PreFooterCards = () => {
  const data = [
    {
      icon: wp_logo,
      text: "24/7 services available",
      heading: "+91 9840562357",
    },
    {
      icon: doc_logo,
      text: "MSME",
      heading: "TN08D0020201",
      blue: true,
    },
    {
      icon: sec_logo,
      text: "Govt. Reg No",
      heading: "TN-02-0346303",
    },
  ];
  return (
    <div className="prefootercards container-fluid py-5">
      <div className="container ">
        <div className="row justify-content-center">
          {data.map((item, index) => (
            <div
              key={index}
              className="card-items col-md-3 col-sm-6 text-center m-3 p-4 row justify-content-center"
              style={{
                backgroundColor: item.blue ? "#4566ad" : "#008631",
              }}
            >
              <div className="row card-icon align-items-center justify-content-center m-2">
                <img src={item.icon} />
              </div>
              <h6 className="card-text">{item.text}</h6>
              <h3 className="card-heading">{item.heading}</h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PreFooterCards;
